import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import thunk from 'redux-thunk';

import reducer from './reducer';
import initialState from './initialState';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store;
if (process.env.NODE_ENV === 'development') {
  store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(thunk)));
  window.store = store;
} else if (process.env.NODE_ENV === 'development-persist') {
  store = createStore(
    reducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk), autoRehydrate())
  );

  const persist = persistStore(store);
  window.purge = () => persist.purge();
} else {
  store = createStore(reducer, initialState, applyMiddleware(thunk));
}
window.store = store;

export default store;



// WEBPACK FOOTER //
// ./src/store.js